import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';

@Injectable({
  providedIn: 'root'
})
export class VmiTanquesService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.administracion;
  }

  getAll(): Observable<any[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.tanques);
  }

  create(innObj: any): Observable<any> {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioUrl.tanques, innObj);
  }

  edit(innObj: any): Observable<any> {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioUrl.tanques, innObj);
  }

  delete(innIdObj: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioUrl.tanques + `/${innIdObj}`);
  }
}
